import type { EstimatesRecord, ID } from '@octopus-do/octopus-project-core'

export const sumEstimateHoursByLineItemId = (
  estimatesById: EstimatesRecord,
  lineItemId: ID
): number =>
  Object.values(estimatesById)
    .filter((estimate) => estimate.lineItemId === lineItemId)
    .reduce((acc, estimate) => acc + estimate.value, 0)
